<template>
  <v-app>
    <AppBar routeTo="signup" btnName="Sign up" />
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="5">
          <v-card width="600" class="pa-4 custom-card" flat>
            <!-- Your card content goes here -->
            <v-form @submit.prevent="login" v-model="isFormValid" ref="form">
              <div
                class="ml-4 mb-2 text-h6 text-md-h5 text-lg-h4 font-weight-bold font-theme"
              >
                Log in
              </div>
              <div class="ml-4 grey2--text mb-2">
                Please enter your details to access the platform
              </div>
              <v-card-text class="pb-0">
                <div class="mb-1 subtitle-2 grey3--text">Email</div>
                <v-text-field
                  v-model="email"
                  placeholder="example@gmail.com"
                  :rules="emailRules"
                  outlined
                  dense
                  prepend-inner-icon="mdi-email"
                ></v-text-field>
                <div class="mb-1 subtitle-2 grey3--text">Password</div>
                <v-text-field
                  v-model="password"
                  outlined
                  placeholder="Enter your password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : passwordFieldType"
                  @click:append="togglePasswordVisibility"
                  dense
                  prepend-inner-icon="mdi-lock"
                ></v-text-field>
                <v-card-text
                  class="display-5 text-right pr-0 row-pointer hover--text mt-1 mb-2"
                >
                  <div @click="forgotPassword">Forgot password?</div>
                </v-card-text>
                <v-btn
                  class="mt-2 primary white--text lowercase-text"
                  block
                  plain
                  :loading="$store.state.loading.loginBtn.load"
                  :disabled="$store.state.loading.loginBtn.disabled"
                  type="submit"
                >
                  Log in
                </v-btn>
                <v-card-text
                  class="display-6 text-center pr-0 row-pointer mt-2"
                >
                  <div class="grey2--text">
                    Don’t have an account?
                    <span
                      @click="routeToHandler"
                      class="hover--text row-pointer"
                      >Sign up</span
                    >
                  </div>
                </v-card-text>
              </v-card-text>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import AppBar from "@/components/shared/AppBar";
export default {
  components: { AppBar },
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      isFormValid: false,
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      passwordFieldType: "password",
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 8 || "Password must be at least 8 characters",
        (v) =>
          /[A-Z]/.test(v) ||
          "Password must contain at least one uppercase letter",
        (v) =>
          /[!@#$%^&*(),.?":{}|<>]/.test(v) ||
          "Password must contain at least one special character",
      ],
    };
  },
  methods: {
    async login() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("login", {
          email: this.email,
          password: this.password,
        });
        if (this.$store.state.user) {
          this.$router.push({ name: "stats" });
        }
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    routeToHandler() {
      this.$router.push({ name: "signup" });
    },
    forgotPassword() {
      this.$router.push({ name: "forgot-password" });
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
